module.exports = __webpack_public_path__ + "static/media/icon-dashboard-resource.e35eaf76.svg";